import React from 'react';
import { CheckCircle, AlertTriangle, XCircle } from 'lucide-react';

interface DocumentValidationStatsProps {
  stats: {
    complete: number;
    incomplete: number;
    noDocuments: number;
  };
}

export default function DocumentValidationStats({ stats }: DocumentValidationStatsProps) {
  return (
    <div className="grid grid-cols-3 gap-4">
      <div className="bg-white rounded-lg border shadow-sm border-l-4 border-l-green-500 p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Dokumen Lengkap</p>
            <p className="text-2xl font-bold">{stats.complete}</p>
          </div>
          <CheckCircle className="w-8 h-8 text-green-500" />
        </div>
      </div>
      <div className="bg-white rounded-lg border shadow-sm border-l-4 border-l-amber-500 p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Dokumen Tidak Lengkap</p>
            <p className="text-2xl font-bold">{stats.incomplete}</p>
          </div>
          <AlertTriangle className="w-8 h-8 text-amber-500" />
        </div>
      </div>
      <div className="bg-white rounded-lg border shadow-sm border-l-4 border-l-red-500 p-4">
        <div className="flex items-center justify-between">
          <div>
            <p className="text-sm text-gray-500">Belum Ada Dokumen</p>
            <p className="text-2xl font-bold">{stats.noDocuments}</p>
          </div>
          <XCircle className="w-8 h-8 text-red-500" />
        </div>
      </div>
    </div>
  );
}
